export default __webpack_public_path__ + "static/media/EAST3180.34I-42096_-25237_0.3cf5c7a0.jpg";